import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { Login } from './pages/Login';
import { SignInComplete } from './pages/SignInComplete';
import { MyBenefits } from './pages/citizen/MyBenefits';
import { Apply } from './pages/citizen/Apply';
import { PaymentHistory } from './pages/citizen/PaymentHistory';
import { CitizenAppeals } from './pages/citizen/Appeals';
import { Dashboard } from './pages/asp-staff/Dashboard';
import { Registry } from './pages/asp-staff/Registry';
import { Claims } from './pages/asp-staff/Claims';
import { WelfareAssessment } from './pages/asp-staff/WelfareAssessment';
import { HomeCare } from './pages/asp-staff/HomeCare';
import { MedicalBoard } from './pages/asp-staff/MedicalBoard';
import { PayRuns } from './pages/asp-staff/PayRuns';
import { Integrity } from './pages/asp-staff/Integrity';
import { StaffAppeals } from './pages/asp-staff/Appeals';
// M27 Family Affairs & Child Protection — a ministry (M-series) module,
// not part of the ASP S-suite above, surfaced here as a 9th asp-staff
// section regardless (see this app's build report). Grouped under its own
// NavHeader in the sidebar below since it contributes six screens, not one.
import { Referrals } from './pages/asp-staff/family-affairs/Referrals';
import { CaseRegister } from './pages/asp-staff/family-affairs/CaseRegister';
import { FosterCare } from './pages/asp-staff/family-affairs/FosterCare';
import { Adoptions } from './pages/asp-staff/family-affairs/Adoptions';
import { Facilities } from './pages/asp-staff/family-affairs/Facilities';
import { DvSupport } from './pages/asp-staff/family-affairs/DvSupport';
import { Shell } from './ui/Shell';

export function App() {
  const { persona } = useAuth();

  if (!persona) {
    return (
      <Routes>
        <Route path="/signin/complete" element={<SignInComplete />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to={`/${persona.workspace}`} replace />} />

      <Route
        path="/citizen"
        element={
          <Shell
            title="My Social Protection"
            items={[
              { to: '/citizen', label: 'My Benefits', icon: '◫' },
              { to: '/citizen/apply', label: 'Apply', icon: '＋' },
              { to: '/citizen/payments', label: 'Payment History', icon: '▤' },
              { to: '/citizen/appeals', label: 'Appeals', icon: '⚖' },
            ]}
          />
        }
      >
        <Route index element={<MyBenefits />} />
        <Route path="apply" element={<Apply />} />
        <Route path="payments" element={<PaymentHistory />} />
        <Route path="appeals" element={<CitizenAppeals />} />
      </Route>

      <Route
        path="/asp-staff"
        element={
          <Shell
            title={persona.title}
            items={[
              { to: '/asp-staff', label: 'Dashboard', icon: '◫' },
              { to: '/asp-staff/registry', label: 'Registry', icon: '⌂' },
              { to: '/asp-staff/claims', label: 'Claims', icon: '≣' },
              { to: '/asp-staff/welfare', label: 'Welfare Assessment', icon: '✓' },
              { to: '/asp-staff/homecare', label: 'Home Care', icon: '♥' },
              { to: '/asp-staff/medboard', label: 'Medical Board', icon: '✚' },
              { to: '/asp-staff/payruns', label: 'Pay Runs', icon: '◎' },
              { to: '/asp-staff/integrity', label: 'Integrity', icon: '◆' },
              { to: '/asp-staff/appeals', label: 'Appeals', icon: '⚖' },

              { header: 'Family Affairs — M27' },
              { to: '/asp-staff/family-affairs/referrals', label: 'Referral Intake', icon: '⚑' },
              { to: '/asp-staff/family-affairs/cases', label: 'Case Register', icon: '▣' },
              { to: '/asp-staff/family-affairs/foster-care', label: 'Foster Care', icon: '⚯' },
              { to: '/asp-staff/family-affairs/adoptions', label: 'Adoptions', icon: '✿' },
              { to: '/asp-staff/family-affairs/facilities', label: 'Facility Licensing', icon: '▤' },
              { to: '/asp-staff/family-affairs/dv-support', label: 'DV Support', icon: '⛨' },
            ]}
          />
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="registry" element={<Registry />} />
        <Route path="claims" element={<Claims />} />
        <Route path="welfare" element={<WelfareAssessment />} />
        <Route path="homecare" element={<HomeCare />} />
        <Route path="medboard" element={<MedicalBoard />} />
        <Route path="payruns" element={<PayRuns />} />
        <Route path="integrity" element={<Integrity />} />
        <Route path="appeals" element={<StaffAppeals />} />

        <Route path="family-affairs/referrals" element={<Referrals />} />
        <Route path="family-affairs/cases" element={<CaseRegister />} />
        <Route path="family-affairs/foster-care" element={<FosterCare />} />
        <Route path="family-affairs/adoptions" element={<Adoptions />} />
        <Route path="family-affairs/facilities" element={<Facilities />} />
        <Route path="family-affairs/dv-support" element={<DvSupport />} />
      </Route>

      <Route path="*" element={<Navigate to={`/${persona.workspace}`} replace />} />
    </Routes>
  );
}
